import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "sending",
  class: "w-full flex flex-col items-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-thin mb-4" }, [
  /*#__PURE__*/_createTextVNode(" Initiating bridge"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("transaction... ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-4" }, [
  /*#__PURE__*/_createTextVNode(" A record of your transaction"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("will be available shortly ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "opacity-70" }, [
  /*#__PURE__*/_createTextVNode(" Transfer dispatched on"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("11/04/21 at 11:40pm UTC ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nft_preview = _resolveComponent("nft-preview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_nft_preview, {
      size: 230,
      asset: _ctx.token.tokenIdentifier.id,
      amount: _ctx.amountBN,
      affected: _ctx.affected,
      fade: ""
    }, null, 8, ["asset", "amount", "affected"]),
    _hoisted_3,
    _hoisted_4
  ]))
}